import React from 'react';

import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText
} from '@mui/material';

import { DateTime } from 'luxon';
import { makeNameAbbreviation } from 'modules/layer00';



export interface IProps {
  messageId: string;
  triggeringUserName: string;
  content: string;
  metaCreated: DateTime;
}

export const FC: React.FC<IProps> = props => {
  const triggeringInfo = props.triggeringUserName ? " by " + props.triggeringUserName : '';

  return (
    <ListItem key={props.messageId}>
      <ListItemAvatar>
        {props.triggeringUserName && (
          <Avatar>{makeNameAbbreviation(props.triggeringUserName)}</Avatar>
        )}
      </ListItemAvatar>

      <ListItemText
        primary={props.content}
        secondary={props.metaCreated.toFormat('yyyy-MM-dd @ hh:mm a') + triggeringInfo} />
    </ListItem>
  );
};
